import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Col } from 'react-bootstrap'

import { LayoutAuth } from 'Components/Layout/Auth'
import { BackgroundLogo } from 'Components/Sidebar/BackgroundLogo'
import { ForgotPasswordForm } from 'Containers/Form/ForgotPassword'
import {
  requestResetPassword,
  initForgotPasswordForm,
} from 'Reducers/Auth/actions'
import { MessagePasswordRequestSend } from 'Components/Message/PasswordRequestSend'

class ForgotPassword extends Component {
  /**
   * Before component is mounted
   */
  componentDidMount() {
    this.props.initForgotPasswordForm()
  }

  /**
   * Render component
   *
   * @returns XML
   */
  render() {
    return (
      <LayoutAuth>
        <Col xs={12} md={6}>
          <BackgroundLogo />
        </Col>
        <Col xs={12} md={6}>
          {this.renderFormOrConfirmationMessage()}
        </Col>
      </LayoutAuth>
    )
  }

  /**
   * Render form or confirmation message
   *
   * @returns JSX.Element
   */
  renderFormOrConfirmationMessage() {
    return this.props.formSubmitted ? (
      <MessagePasswordRequestSend email={this.props.passwordResetEmail} />
    ) : (
      <ForgotPasswordForm
        formSubmitting={this.props.formSubmitting}
        errorMessage={this.props.errorMessage}
        onSubmit={this.onSubmit}
      />
    )
  }

  /**
   * Submit form (request for resetting password)
   *
   * @param values
   */
  onSubmit = values => {
    this.props.requestResetPassword(values.email)
  }
}

const mapStateToProps = state => ({
  formSubmitting: state.auth.formSubmitting,
  formSubmitted: state.auth.formSubmitted,
  passwordResetEmail: state.auth.passwordResetEmail,
  errorMessage: state.auth.errorMessage,
})

export default connect(
  mapStateToProps,
  {
    requestResetPassword,
    initForgotPasswordForm,
  },
)(ForgotPassword)



// WEBPACK FOOTER //
// ./src/Containers/Auth/ForgotPassword/index.js